import React from "react";
import ReactDOM from "react-dom";
// TODO: setup switching of amazon vs google css based on config

import LoginTermAccept from "./components/LoginTermAccept";
import LoginForm from "./components/LoginForm";
import LoginHeader from "./components/LoginHeader";
import LoginFooter from "./components/LoginFooter";
import LoginCreatePin from "./components/LoginCreatePin";
import config from "./clientconfig.json";
import "../node_modules/font-awesome/css/font-awesome.min.css";
import "./index-amz.css";
import "./common.css";
import blackBox from "./BlackBoxID";

class LoginApp extends React.Component {
    constructor(props) {
        super(props);
        // Set client config
        this.clientConfig = config.amz;
        this.state = {
            screen: "",
            config: this.clientConfig,
            blackbox:  {},
            analytics: {},
            pinTimeout: false
        };

        this.params = window.location.search;
        this.handleAcceptTerms = this.handleAcceptTerms.bind(this);
        this.handleLogin = this.handleLogin.bind(this);
        this.handlePin = this.handlePin.bind(this);
        this.handlePinTimeout = this.handlePinTimeout.bind(this);
    }
    componentWillMount() {
        // Analytics (global var for Omniture to consume)
        // Common values can be found in clientconfig.json
        // TODO: detect for service <desk/tab/mobi>
        // TODO:
        /*
        let analyticsConfig = {
            pageInfo: {
                Country_Language: "us|en",
                SiteIdentifier: this.clientConfig.analytics.site_identifier,
                Device: "mobi",
                PNL: this.clientConfig.analytics.pnl,
                ClientName: this.clientConfig.analytics.client_name,
                CustomerType: this.clientConfig.analytics.customer_type,
                Product: this.clientConfig.analytics.product,
                PageKind: this.clientConfig.analytics.page_kind,
                PageFunction: "",
                PageSubFunction: "",
                pageName: ""
            }
        };
        this.setState({
            analytics: analyticsConfig
        });
         window._SFDDL = analyticsConfig;*/
    }
    componentDidMount = async () => {
        /*
        // Load analytics JS AFTER React Lib and Code bundle
        var analyticsScript = document.createElement("script");
        analyticsScript.type = "text/javascript";
        analyticsScript.src =
            "//nexus.ensighten.com/synchrony/dservicedev/Bootstrap.js";
        document.body.appendChild(analyticsScript);
        */

        const { blackbox } = await blackBox();
        this.setState({blackbox: blackbox});
    }
    handleAcceptTerms() {
        this.setState({ screen: "LoginForm" });
    }

    handleLogin(sessionId, userId) {
        if (sessionId) {
            this.setState({ screen: "LoginCreatePin" });
            this.setState({ sessionId: sessionId });
            this.setState({ userId: userId });
        } else {
            this.setState({ screen: "Loading" });
        }
    }

    handlePin(pin) {
        this.setState({ screen: "Loading" });
    }

    handlePinTimeout() {
        this.setState({ screen: "LoginForm", pinTimeout: true });
    }

    loading() {
        this.setState({ loadingVisible: true });
    }

    render() {
        var partial;
        if (this.state.screen === "LoginForm") {
            partial = (
                <LoginForm
                    pinTimeoutErr={this.state.pinTimeout}
                    onPush={this.handleLogin}
                    config={this.state.config}
                    blackboxId={this.state.blackbox}
                    // analytics={this.state.analytics}
                />
            );
        } else if (this.state.screen === "LoginCreatePin") {
            partial = (
                <LoginCreatePin
                    onPush={this.handlePin}
                    onTimeout={this.handlePinTimeout}
                    sessionId={this.state.sessionId}
                    userId={this.state.userId}
                    config={this.state.config}
                    //   analytics={this.state.analytics}
                />
            );
        } else {
            partial = (
                <LoginTermAccept
                    onPush={this.handleAcceptTerms}
                    config={this.state.config}
                    // analytics={this.state.analytics}
                />
            );
        }
        return (
            <div className="login-screen">
                <LoginHeader config={this.state.config} />
                <main className="login-body">{partial}</main>
                <LoginFooter
                    config={this.state.config}
                    //  analytics={this.state.analytics}
                />
            </div>
        );
    }
}

ReactDOM.render(<LoginApp />, document.getElementById("root"));
